import React from 'react'
import {Button, Modal} from 'react-bootstrap'
import {parseId} from '../../../helpers'
import {CommissionReportActivityTab} from './CommissionReportActivityTab'

interface IModalViewCommissionReportLogsProps {
  id: string
  isOpen: boolean
  onClose: () => void
}

export const ModalViewCommissionReportLogs: React.FC<IModalViewCommissionReportLogsProps> = ({
  id,
  isOpen,
  onClose,
}) => {
  return (
    <Modal show={isOpen} onHide={onClose} size='xl'>
      <Modal.Body>
        <CommissionReportActivityTab id={String(parseId(id))} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' size='sm' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
